const styles = {
  dropZone: {
    border: '2px dashed',
    borderColor: 'primary.light',
    borderRadius: 2,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 3,
    paddingRight: 3,
    textAlign: 'center',
    cursor: 'pointer',
    transition:
      'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease',
    marginBottom: 3,
    outline: 'none',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'rgba(25, 118, 210, 0.06)',
      boxShadow: '0 10px 24px rgba(25, 118, 210, 0.18)',
      transform: 'translateY(-2px)',
    },
    '&:focus-visible': {
      borderColor: 'primary.main',
      backgroundColor: 'rgba(25, 118, 210, 0.1)',
      boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.2)',
    },
  },
  dropZoneActive: {
    borderColor: 'primary.main',
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    boxShadow: '0 12px 28px rgba(25, 118, 210, 0.25)',
    transform: 'translateY(-3px)',
  },
  helper: {
    color: 'text.secondary',
    marginTop: 1,
  },
  caption: {
    marginTop: 2,
    display: 'block',
  },
  icon: {
    fontSize: 48,
    marginBottom: 1,
  },
}

export default styles
